import { render, staticRenderFns } from "./EditSyaratSOSPopup.vue?vue&type=template&id=8a96f894"
import script from "./EditSyaratSOSPopup.vue?vue&type=script&lang=js"
export * from "./EditSyaratSOSPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports